
export const defaultCheck = {
    check_id: null,
    pallet_id: null,
    growercode: null,
    avocados: [],
    is_valid: null,
    message: null,
    is_maxi_check: 0,
};

export enum DEFECT_POSITION {
    EXTERNAL = "external",
    INTERNAL = "internal",
    LEGAL = "legal",
    COMMERCIAL = "commercial",
    COSMETIC_FRUIT = "cosmetic_fruit",
    COSMETIC_CROWN = "cosmetic_crown",
    FYTOSANITARY = "fytosanitary",
    MATURITY = "maturity",
    CONDITION = "condition",

}

export enum DEFECT_SEVERITY {
    MINOR = "minor",
    MAJOR = "major",
    UNACCEPTABLE = "unacceptable",
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    LIGHT = "light",
    MEDIUM = "medium",
    SEVERE = "severe",
}
